<template>
    <div class="sticky-top">
    <b-navbar toggleable="lg" type="dark" variant="info">
      <span @click="toHomePage" class="btn"><b-navbar-brand><b-icon-collection-fill/> U-Shoes</b-navbar-brand></span>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto" v-if="user != undefined || user != null">
            <div class="text-center">
              <b-button variant="dark" @click="toCartPage">
                  <b-icon-cart4/> Cart <b-badge variant="light"> {{ totalCarts }}</b-badge>
              </b-button>
            </div>

            <b-nav-item-dropdown right>
            <!-- Using 'button-content' slot -->
            <template v-slot:button-content>
                <em>{{ user }} </em>
                <b-icon-person-circle/>
            </template>
            <b-dropdown-item href="#">Profile</b-dropdown-item>
            <b-dropdown-item @click="logout">Logout</b-dropdown-item>
            </b-nav-item-dropdown>
        </b-navbar-nav>
        <b-navbar-nav class="ml-auto" v-else >
          <button class="btn btn-success ml-2" @click="tologin">Login</button>
        </b-navbar-nav>
        </b-collapse>
    </b-navbar>
    </div>
</template>

<script>
export default {
  name: 'Navbar',
  data () {
    return {
      user: this.$store.state.user
    }
  },
  computed: {
    totalCarts () {
      return this.$store.state.totalCarts
    }
  },
  methods: {
    logout () {
      this.$store.dispatch('logout')
    },
    tologin () {
      this.$router.push({ name: 'Login' })
    },
    toCartPage () {
      this.$router.push({ name: 'Cart' })
    },
    toHomePage () {
      this.$router.push({ name: 'Home' })
    }
  }
}
</script>

<style>

</style>
